// Player settings (Settings in the header menu). Saved on the account so they
// follow the player across devices, and mirrored to localStorage so the game
// page (public/game/jangle.html, same origin) can read them and pick up
// changes live through the "storage" event.
export const SETTINGS_KEY = "jangle:settings";

export const SETTINGS_DEFAULTS = {
  kb_highlight: "bright",
  word_arrows: "on",
  mino_pow: "off",
  crown: "on",
  lh_avatar: "detective",
  colour: "default",
  board_style: "normal",
};

export function readLocalSettings() {
  try {
    const v = JSON.parse(localStorage.getItem(SETTINGS_KEY) || "null");
    return { ...SETTINGS_DEFAULTS, ...(v && typeof v === "object" ? v : {}) };
  } catch {
    return { ...SETTINGS_DEFAULTS };
  }
}

export function writeLocalSettings(settings) {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify({ ...SETTINGS_DEFAULTS, ...(settings || {}) }));
  } catch { /* storage blocked: the game falls back to the defaults */ }
}
